import { ResetPasswordManager } from '../ResetPasswordManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class ResetPasswordManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/reset-password`, headers);
  }

  public createResetPasswordManager(): ResetPasswordManager {
    return new ResetPasswordManager(this.apiClientFactory.createClient());
  }
}
